import { withTheme } from '@emotion/react';
import { motion } from 'framer-motion';

const AnimatedBox = withTheme(motion.div);

export default AnimatedBox;
